export default "__VITE_ASSET__884700b1__"